import { AppEnum ,DateFormatHelper,OptionHelper, PlanningEnums, RecordMap } from "@/Shared";

import { ContactModel, UserModel, PropertyModel } from '@/Domains';
import { PlanningModel } from '../Models/PlanningModel';
import { PlanningFormValues } from "../PlanningFormValidation";


export class PlanningFormViewModel {

    private _userOptions = [] as AppEnum[];
    private _contactOptions = [] as AppEnum[];
    private _propertyOptions = [] as AppEnum[];
    
    public constructor(
        private _viewEnums : PlanningEnums,
        private _contactModelMap: RecordMap<ContactModel>,
        private _agentModelMap: RecordMap<UserModel>,
        private _propertyModelMap: RecordMap<PropertyModel>,
        private _enrichedPlanning?: PlanningModel) {
            
            this._contactOptions = OptionHelper.contactOptions(this._contactModelMap.toArray());
            this._userOptions = OptionHelper.userOptions(this._agentModelMap.toArray());
            this._propertyOptions = OptionHelper.propertyOptions(
                this._propertyModelMap.toArray(), 
                this._viewEnums.PropertyTypeEnum
            );
         }

    getError = (error?: string) => error || "Une erreur s'est produite";

    getSuccess = () => this._enrichedPlanning ? "Planning mise à jour avec succés" : "Planning créé avec succés";

    get formValues() {
        return {
            planningDate : DateFormatHelper.toInput(this._enrichedPlanning?.planningDate) || "",
            startTime : this._enrichedPlanning?.startTime ?? "",
            endTime : this._enrichedPlanning?.endTime ?? "",
            note : this._enrichedPlanning?.note ?? "",
            feedback : this._enrichedPlanning?.feedback ?? "",
            remarks : this._enrichedPlanning?.remarks ?? "",
            type : this._enrichedPlanning?.type ?? "",
            contactId : this._enrichedPlanning?.contactId ?? "",
            propertyIds : this._enrichedPlanning?.propertyVisits?.map(pv => pv.propertyId) ?? [],
            agentId : this._enrichedPlanning?.agentId ?? ""
        } as PlanningFormValues
    }

    get id() {
        return this._enrichedPlanning?.id;
    }

    get planningTypeOptions(): AppEnum[] {
        return OptionHelper.sortByLabel(this._viewEnums.PlanningTypeEnum);
    }

    get contactOptions(): AppEnum[] {
        return this._contactOptions;
    }
    get userOptions(): AppEnum[] {
        return this._userOptions;
    }

    get propertyOptions(): AppEnum[] {
        return this._propertyOptions;
    }

    get title() {
        const  getFullName  = () => {
            const person = this._enrichedPlanning?.agent?.person;
            return person ? (person?.lastname?.toUpperCase() || "") + " " + (person?.firstname || "") : "Inconnu";
        }
        
        return this._enrichedPlanning?.id ? "Planning de " + getFullName()  : "Création de planning";
    }
}